import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx-js-style';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  exportToExcel(columns: any[], data: any[], applyCss: boolean = false, fileName: string = 'Export') {
    const excelData = data?.map((row: any) => {
      const filteredRow: any = {};
      columns.filter(c => c.selected).forEach((col: any) => {
        filteredRow[col.label] = row[col.field] ?? '';
      });
      return filteredRow;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const selectedColumns = columns.filter(c => c.selected);
    worksheet['!cols'] = selectedColumns.map(() => ({ wch: 20 }));

    // Apply header background color
    selectedColumns.forEach((col, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          fill: { fgColor: { rgb: 'FFFF00' } },
          font: { bold: true }
        };
      }
    });

    // Apply due_color to disbursement_id column
    if (applyCss) {
      data.forEach((row: any, rowIndex: number) => {

        if (row.due_color) {
          selectedColumns.forEach((col: any, colIndex: number) => {
            const cellAddress = XLSX.utils.encode_cell({
              r: rowIndex + 1,
              c: colIndex
            });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = {
                fill: {
                  patternType: "solid",
                  fgColor: { rgb: row.due_color.replace('#', '') }
                },
              };
            }
          });
        }
      });
    }

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Disbursement');
    XLSX.writeFile(workbook, `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`);
  }
}
